import styled from 'styled-components';

export const StyledCatalog = styled.section`
  width: 100%;
  padding-top: 20px;
`;

export const CatalogContainer = styled.div`
  margin: 0 auto;
  width: 100%;

  @media ${props => props.theme.media.desktop} {
    padding: 0;
`;
